import { useOrgUser } from '@cibo/profile'
import { useProgramContent } from '@cibo/programs'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'
import { useParamAsInteger } from '../../consts/Theme'
import { GrowersRouteParams } from '../../navigation/types'

export const useBreadcrumbs = () => {
  const location = useLocation()
  const allPaths = location.pathname.split('/')
  // only breadcrumb up to the engagement name
  const paths = allPaths.slice(1, 4)
  const { t } = useTranslation('impact/pages/GrowersLayout')

  const { programId } = useParams<GrowersRouteParams>()
  const userId = useParamAsInteger('userId')

  const user = useOrgUser(userId)
  const program = useProgramContent(programId)

  const pathLabel = useCallback(
    (path: string) => {
      if (path === userId?.toString()) {
        if (user.data?.displayNameFull) {
          return user.data.displayNameFull
        }
        return t('loading')
      }
      if (path === programId) {
        if (program.data?.content?.fields?.title) {
          return program.data.content.fields.title
        }
        return t('loading')
      }
      return t(`path_${path}`)
    },
    [user.dataUpdatedAt, userId, program.dataUpdatedAt, programId]
  )

  return paths.map((path, index) => ({
    name: pathLabel(path),
    to: index === paths.length - 1 ? undefined : `/${paths.slice(0, index + 1).join('/')}`,
  }))
}
